module.exports = __webpack_public_path__ + "fonts/96afcb04/proximanova-boldit-webfont.eot";